import React from "react";
import { NamePrefixProvider, useInputFullName } from "./NamePrefixContext";
import UserAttributeMetadataPaper from "../../attributeMetadata/UserAttributeMetadataPaper";

export interface SubFormProps {
  name: string;
  children?: React.ReactNode;
}

const SubForm: React.FC<SubFormProps> = ({ children, name }) => {
  const fullName = useInputFullName(name);

  return (
    <UserAttributeMetadataPaper name={fullName}>
      <NamePrefixProvider prefix={name}>{children}</NamePrefixProvider>
    </UserAttributeMetadataPaper>
  );
};

export default SubForm;
